import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const etron: PartialCarConfiguration = {
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'electricRanges', 'chargingTime'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'total',
			hiddenPriceParts: [
				'financeableTotal',
				'total',
				'taxTotal',
				'taxTotalWeight',
				'totalRate',
				'taxTotalNOx',
				'taxTotalCO2',
				'importCharge',
				'destinationCharge',
			],
			vatConfig: {
				feature: 'exclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {
					evVatTotal: 'hidden', // MVA
					financeableTotal: 'inclusive',
					nonFinanceableTotal: 'inclusive',
					model: 'inclusive',
					options: 'inclusive',
					total: 'inclusive',
					totalRate: 'hidden',
				},
			},
		},
	},
};
